import { GithubCachesPage } from '@internal/plugin-github-caches';
import React from 'react';

import { EntityGithubActionsContent } from '@backstage-community/plugin-github-actions';
import { TabbedCard, CardTab } from '@backstage/core-components';

export const CICDContent = (
  <TabbedCard title="CI/CD">
    <CardTab label="GitHub Actions Workflows">
      <EntityGithubActionsContent />
    </CardTab>
    <CardTab label="GitHub Actions Self-Hosted Caches">
      <GithubCachesPage />
    </CardTab>
  </TabbedCard>
);
